import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-checkbox',
   templateUrl: './checkbox.component.html',
   styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: string;
   @Input() labelName: any;
   @Input() choices: any;
   @Input() hideHeader: boolean = false;
   checkboxInvalid = false;
   data = [];
   lang: string;
   choiceDefaultValue: string;
   value: any;

   constructor(private eformService: EformService) {
   }

   ngOnInit(): void {
      this.setData();
   }

   setData() {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      if (this.field.choices) {
         for (let i = 0; i < this.field.choices.length; i++) {
            this.data[i] = !this.field.required;
         }
         if (this.field.choiceOption === 0) {
            this.choiceDefaultValue = (this.field.choiceDefaultValue !== '-1') ?
               this.field.choiceDefaultValue.toString() : '';
         } else {
            this.choiceDefaultValue = this.field.tempLookupDefault.toString();
         }
      }
      if (this.choiceDefaultValue !== '') {
         this.data[0] = true;
      }
      this.checkboxInvalid = this.checkAllSelected(this.data);
   }

   validateData() {
      this.checkboxInvalid =  this.form.controls[this.fieldName].valid;
   }

   getChoice(key: any){
      let checked: boolean;
      if (this.value) {
         checked = this.value[key];
      } else {
         checked = this.choiceDefaultValue === key.toString();
      }
      return checked;
   }

   getValue(choice){
      let checked: boolean;
      let getKey = this.switchContent(this.eformService.storeChoiceString(choice), 0);
      if (this.value) {
         checked = this.value[getKey.toLowerCase()];
      } else {
         checked = this.field.radioDefaultValue === 'true';
      }
      return checked;
   }

   switchContent(content, indexString: number) {
      const x  = content.split('/');
      return indexString === 0 ? x[0] : x[1];
   }

   checkAllSelected(item) {
      for (let i = 0; i < item.length; i++) {
         if (item[i] === true) {
            return true;
         }
      }
      for (const key in this.value) {
         if (this.value[key]) {
            return true;
         }
      }
      return false;
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }
}
